/** CarPilot360 APS Scheel hosts: production and staging. */
const APS_SCHEEL_CARPILOT_SUBDOMAINS = new Set(["aps", "aps-staging"]);

/** inside-fleet.de test environment for APS (same product rules as aps / aps-staging). */
const INSIDE_FLEET_APS_TEST_SUBDOMAIN = "staging";
function getSubdomain(hostname: string, baseDomain: string): string | null {
  const normalized = hostname.toLowerCase();
  const suffix = `.${baseDomain}`;

  if (!normalized.endsWith(suffix)) {
    return null;
  }

  const labels = normalized.split(".");
  const baseLabelCount = baseDomain.split(".").length;

  if (labels.length <= baseLabelCount) {
    return null;
  }

  return labels[0];
}

function resolveIsApsScheelCustom(): boolean {
  const hostname = window.location.hostname;
  const carPilotSubdomain = getSubdomain(hostname, "carpilot360.de");

  if (carPilotSubdomain !== null) {
    return APS_SCHEEL_CARPILOT_SUBDOMAINS.has(carPilotSubdomain);
  }

  const insideFleetSubdomain = getSubdomain(hostname, "inside-fleet.de");

  if (insideFleetSubdomain !== null) {
    return insideFleetSubdomain === INSIDE_FLEET_APS_TEST_SUBDOMAIN;
  }

  return false;
}

/**
 * True on APS Scheel deployments:
 * - `aps.carpilot360.de` (production)
 * - `aps-staging.carpilot360.de` (CarPilot staging)
 * - `staging.inside-fleet.de` (inside-fleet APS test environment)
 *
 * False on other tenant hosts (e.g. `acme.carpilot360.de`) and local dev (`localhost`).
 */
export const isApsScheelCustom = resolveIsApsScheelCustom();

/**
 * Bulk service catalog import (admin). Enabled on CarPilot360 tenant hosts, not on APS Scheel subdomains.
 * Kept separate from {@link isApsScheelCustom} so CarPilot tenant URLs are not treated as APS for the rest of the app.
 */
export const allowsServiceCatalogBulkImport = !isApsScheelCustom;
